import { Component, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IchService } from '../service';

@Component({
  selector: 'fa-kt-ich-detail',
  templateUrl: './ich-detail.component.html',
  styleUrls: ['./ich-detail.component.css'],
})
export class IchDetailComponent {
  $loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  @Input() set loading(loading: boolean) {
    this.$loading.next(this.$loading.getValue() || loading);
  }
  @Input() height = 'calc(100vh - 324px)';

  constructor(public ich: IchService) {}
}
